const getters = {
  userno: state => state.userno.userno,
  asyncRouterEnd: state => state.asyncRouter.asyncRouterEnd,
  addRouters: state => state.asyncRouter.addRouters,
  base_api: state => state.home.base_api,
  disablePage: state => state.home.disablePage,
  companyInfo: state => state.home.companyInfo,
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  permission: state => state.user.permission,
  acctInfo: state => state.user.acctInfo,
  popupLogin: state => state.user.popupLogin
}
export default getters
